// extracted by mini-css-extract-plugin
export var orderDetails = "_pe-2";
export var orderImage = "_pe-1";
export var orderMeta = "_pe-3";
export var orderSummary = "_pe-0";
export var rightArrow = "_pe-4";